import { render, staticRenderFns } from "./TherapyServicesTable.vue?vue&type=template&id=0ab82c72"
import script from "./TherapyServicesTable.vue?vue&type=script&lang=js"
export * from "./TherapyServicesTable.vue?vue&type=script&lang=js"
import style0 from "./TherapyServicesTable.vue?vue&type=style&index=0&id=0ab82c72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports